import type { JSX, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import formStyles from '../../../styles/forms.module.scss';

interface YourDataNotesProps {
  notes?: string;
  filenames?: string[] | null;
}

function YourDataNotes({
  notes = '',
  filenames = null,
}: YourDataNotesProps): JSX.Element {
  let content: JSX.Element | undefined;

  if (notes || filenames) {
    let notesContent: ReactNode;
    let filesContent: ReactNode;

    if (notes) {
      notesContent = (
        <div>
          <FormattedMessage id="offerWizard.yourData.notes" />
          <br />
          <span className={formStyles.breakWordAll}>{notes}</span>
        </div>
      );
    }

    if (filenames) {
      filesContent = (
        <div>
          <FormattedMessage id="offerWizard.yourData.notes.files" />
          <br />
          {filenames.map((filename) => (
            <div key={filename}>{filename}</div>
          ))}
        </div>
      );
    }

    content = (
      <>
        {notesContent}
        {filesContent}
      </>
    );
  }

  if (!content) {
    content = <FormattedMessage id="offerWizard.yourData.notes.noNotes" />;
  }

  return content;
}

export default YourDataNotes;
